import {combineReducers} from 'redux';
import {responsiveStateReducer} from 'redux-responsive';

import {connectRouter} from 'connected-react-router';

import {FEATURES} from '@constants/features';
import {ROUTE_URLS} from '@constants/routes';

import {featureToggle} from '@utils/featureToggle/featureToggle';

import history from '../services/history';
import categoriesReducer from './modules/categories';
import communicatorReducer from './modules/communicator';
import drawersReducer from './modules/drawers';
import localizationReducer from './modules/localization';
import locationsReducer from './modules/locations';
import loginReducer from './modules/login';
import notificationReducer from './modules/notification';
import organizationReducer from './modules/organization';
import personMatchingPatternsReducer from './modules/personMatchingPatterns';
import personTypesReducer from './modules/personTypes';
// TODO Preferences are here due to auth component/page needing to be officially loaded is this still the case?
import preferencesReducer from './modules/preferences';
import preferencesFilterReducer from './modules/preferences-filter';
import sessionReducer from './modules/session';
import sitesReducer from './modules/sites';

export const staticReducers = {
  browser: responsiveStateReducer,
  router: connectRouter(history),
  session: sessionReducer,
  localization: localizationReducer,
  notification: notificationReducer,
  locations: locationsReducer,
  categories: categoriesReducer,
  sites: sitesReducer,
  login: loginReducer,
  drawers: drawersReducer,
  preferences: preferencesReducer,
  personTypes: personTypesReducer,
  communicator: communicatorReducer,
  preferencesFilter: preferencesFilterReducer,
  personMatchingPatterns: personMatchingPatternsReducer,
  organization: organizationReducer,
};

export default function createReducer(asyncReducers) {
  const reducers = {
    ...staticReducers,
    ...asyncReducers,
  };

  const reducer = combineReducers(reducers);

  if (!featureToggle(FEATURES.MAP_FILTERS_CONTEXT)) {
    return reducer;
  }

  const mapReducers = {...reducers};
  delete mapReducers.worldMap;
  const mapReducer = combineReducers(mapReducers);

  return (state, action) => {
    const router = reducers.router(state?.router, action);
    if (router.location.pathname !== ROUTE_URLS.MAP) {
      return reducer(state, action);
    }

    if (state && Object.prototype.hasOwnProperty.call(state, 'worldMap')) {
      const mapState = {...state};
      delete mapState.worldMap;
      return mapReducer(mapState, action);
    }

    return mapReducer(state, action);
  };
}
